import cn from 'classnames';
import Button from 'components/button-new';
import { AnimatePresence, m } from 'motion/react';
import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

interface Props extends React.PropsWithChildren {
  className?: string;
  isOpen: boolean;
  hasButtons?: boolean;
  onBack?: () => void;
  onConfirm?: () => void;
}

/**
 * Animate Dropdown component of the NeedCapture component
 */
const AnimateDropdown: React.FC<Props> = ({
  children,
  className,
  isOpen,
  hasButtons = false,
  onBack,
  onConfirm,
}) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <m.div
          data-test="animate-dropdown"
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.15, ease: 'easeInOut' }}
          className={cn(
            'bg-other-white text-grey-800 absolute top-10 z-50 mt-1 max-h-72 w-full overflow-auto rounded-lg text-sm font-normal shadow-md',
            className
          )}
        >
          <div className="relative">
            <div className="overflow-y-auto pb-2">{children}</div>
            {hasButtons && (
              <div
                data-test="animate-dropdown-buttons"
                className="bg-other-white shadow-top sticky bottom-0 flex w-full gap-5 px-4 py-3"
              >
                <Button
                  data-test="animate-dropdown-back-button"
                  size="large"
                  className="w-auto! min-w-20.5"
                  layout="outline"
                  onClick={onBack}
                >
                  <FormattedMessage id="common:buttons:back" />
                </Button>

                <Button
                  data-test="animate-dropdown-confirm-button"
                  size="large"
                  className="w-auto! min-w-26"
                  onClick={onConfirm}
                >
                  <FormattedMessage id="landingpage:need-capture:need:selector:cta:confirm" />
                </Button>
              </div>
            )}
          </div>
        </m.div>
      )}
    </AnimatePresence>
  );
};

export default memo(AnimateDropdown);
